import axios from 'axios';
import { queryCache, useMutation } from 'react-query';

const updateConcept = ({ id, payload }) => {
  return axios.put(`/api/v3/concepts/${id}`, payload);
};

export const useMutateConcept = (itemId: string = '', setId: string = '', conceptIdForDistractors: string = '') => {
  return useMutation(updateConcept, {
    onError: (error: any) => {
      console.error(`ERROR! ${error}`);
    },
    onSettled: () => {
      queryCache.invalidateQueries(`item-${itemId}`);
      queryCache.invalidateQueries(['assignmentItems', setId]);
      queryCache.invalidateQueries(['distractors', conceptIdForDistractors]);
    },
  });
};
